import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { OverlayEventDetail } from '@ionic/core';
import { AlertController, ModalController } from '@ionic/angular';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

interface ApiResponse {
  login: boolean;
  txt: any;
  msg?: string;
  des?: string;
  eenh?: string;
  loc?: string;
  vrd?: number;
  vvrd?: number;
  mvrd?: number;
  verbruik?: any;
  foto?: boolean;
  serienr?: string;
}

@Component({
    selector: 'app-afboeking',
    templateUrl: './afboeking.page.html',
    styleUrls: ['./afboeking.page.scss'],
    standalone: false
})
export class AfboekingPage implements OnInit {
  artlist: any[] = [];
  artlistReqnr = 0;
  artlistAnswer = 0;
  inpArtnr = '';
  inpArtSubject: Subject<string> = new Subject();
  blockArtList = false;
  scanCamera = false;
  artShow: any = {
    nr: '0123456',
    descr: 'Voorbeeld artikel',
    voorraad: 11,
    voorraadTxt: '',
    afgeboekt: '',
    vrijevoorraad: 10,
    verbruik: 100,
    locatie: '1ZA203',
    minvr: 3
  };

  inpProjnr = '';
  inpProjSubject: Subject<string> = new Subject();
  blockProjList = false;
  projlist: any[] = [];
  projShow: any = {
    nr: '123',
    descr: 'Voorbeeld project',
  };
  projError = '';

  inpQty: number = null;
  inpOms = '';
  doShowOmschr = false;
  validArt = false;
  withSN = false;
  inpSNr = '';

  typeBoeking = -1;  // -1=afboeking, +1=retourboeking
  typeBoekingOmsch = 'Afboeken';
  validBoeking = false;
  projValid = false;

  imgs = [];
  viewerOpen = false;

  @ViewChild('inpArtFld', {static: false}) inpArtFld: ElementRef;
  @ViewChild('inpQtyFld', {static: false}) inpQtyFld: ElementRef;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    public global: GlobalService,
    public alertController: AlertController,
    public modalController: ModalController,
    public http: HttpClient,
    private ajax: AjaxService,
  ) { }

  ngOnInit() {
    if (!this.global.isLoggedIn) {
      this.router.navigateByUrl('login');
    }

    this.inpProjSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(
      value => {
        this.onChangeProj(value);
      }
    );
    this.inpArtSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(
      value => {
        this.onChangeArt(value);
      }
    );

  }

  ionViewWillEnter() {
    this.doShowOmschr = (this.global.getvar('app-voorraad-omschr', '0') === '1');

    const  projnr: string = localStorage.getItem('lastProjNr');
    if (projnr) {
      this.inpProjnr = projnr;
      this.showProjKaart(projnr);
    }

    const artnr: string = localStorage.getItem('lastArtNr');
    if (artnr) {
      this.inpArtnr = artnr;
      this.showArtKaart(artnr);
    }

    this.inpArtFld.nativeElement.focus();
  }

  /*---------------------
  * PROJECT INVOER
  ----------------------- */
  async doScanProj() {
    if (!await this.global.startCamera()) {
        return;
    }
     this.scanCamera = true;
     const myDlg = await this.modalController.create({
         component: ScanCameraPage,
     });
     myDlg.onDidDismiss()
     .then((dataPar: OverlayEventDetail) => {
         this.scanCamera = false;
         if (dataPar.data.code) {
             this.inpProjnr = dataPar.data.code;
             this.showProjKaart(this.inpProjnr);
        }
     });
     return await myDlg.present();
  }


  projChanged(event) {
    //this.inpProjSubject.next(event);
    this.onChangeProj(this.inpProjnr);
  }

  // Called during typing of projectnr
  onChangeProj(nwProjNr) {
    this.projShow.descr = '-- ONBEKEND --';
    if (!this.blockProjList) {
      console.log('onChangeProj: ' + nwProjNr);
      this.ajax.get('projList', {req: nwProjNr})
      .then((data: any) => {
          if (!data.login) {
            this.dataError(data);
          } else {
            console.log('ProjList = ', data);
            this.projlist = data.txt;
            if (this.projlist.length === 0) {
                this.projError = 'Geen project gevonden';
            } else if (this.projlist.length === 1
              && this.projlist[0].nr.toLowerCase() === nwProjNr.toLowerCase()) {
                this.click_proj(this.projlist[0].nr);
            } else {
              this.projError = 'Selecteer een project';
              data.txt.forEach(element => {
                if (element.nr.toLowerCase() === nwProjNr.toLowerCase()) {
                  this.showProjKaart(nwProjNr);
                }
              });
            }
          }
        }
      );
    }
  }

  click_proj(nwProjNr) {
    this.inpProjnr = nwProjNr;
    this.projlist = [];
    this.showProjKaart(nwProjNr);
  }

  showProjKaart(projnr) {
    console.log('showProjKaart: ' + projnr);
    this.projShow.descr = '-- ONBEKEND --';
    this.projShow.verbruik = [];

    this.ajax.get('projValid', {
      req: this.inpProjnr
    })
    .then((data: any) => {
      this.projValid = (data.qty > 0);
      console.log('projValid', this.projValid);
      this.projError = data.txt;
      this.ajax.get('projData', {req: projnr})
      .then((projdata: any) => {
          if (!projdata.login) {
            this.dataError(projdata);
          } else {
            console.log('got6 = ', projdata);
            this.projShow.descr = projdata.des;
            this.projShow.verbruik = projdata.verbruik;
            this.updateAfgeboekt();
            this.doCheckValid();

            this.global.currProjNr = projnr;
            localStorage.setItem('lastProjNr', projnr);
            this.inpArtFld.nativeElement.focus();
            this.inpArtFld.nativeElement.select();
          }
        }
      );
    });
  }

  /*---------------------
  * ARTIKEL INVOER
  ----------------------- */

  async doScanArt() {
    if (!await this.global.startCamera()) {
        return;
    }
    this.scanCamera = true;
    const myDlg = await this.modalController.create({
        component: ScanCameraPage,
    });
    myDlg.onDidDismiss()
    .then((dataPar: OverlayEventDetail) => {
        this.scanCamera = false;
        if (dataPar.data.code) {
            this.showArtKaart(dataPar.data.code);
       }
    });
    return await myDlg.present();
  }

  artChanged(event) {
    this.inpArtSubject.next(event);
  }

  // called during typing of partnr
  onChangeArt(nwArtNr) {
    if (!this.blockArtList) {
        console.log('onChangeArt: ' + nwArtNr);
        this.artlistReqnr++;
        this.ajax.get('artList', {req: nwArtNr.trim(), reqnr: this.artlistReqnr})
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                console.log('artList = ', data);
                if (data.params.reqnr > this.artlistAnswer) {
                    this.artlistAnswer = data.params.reqnr;
                    this.artlist = data.txt;
                    if ((this.artlist.length === 1 && this.artlist[0].nr.toLowerCase().trim() === nwArtNr.toLowerCase().trim())
                        || data.msg === 'FOUND 1'
                    ) {
                        this.click_art(this.artlist[0].nr.trim());
                    } else {
                        data.txt.forEach(element => {
                            if ( element.nr.toLowerCase().trim() === nwArtNr.toLowerCase().trim() ) {
                                this.showArtKaart(nwArtNr.trim());
                            }
                        });
                    }
                }
            }
        });
    }
  }

  click_art(nwArtNr) {
    this.inpArtnr = nwArtNr;
    this.artlist = [];
    this.showArtKaart(nwArtNr);
  }

  // when partnr fulfilled, show details
  showArtKaart(artnr) {
    artnr = artnr.trim();
    console.log('showArtKaart: ' + artnr);
    this.artShow.descr = '--';
    this.artShow.voorraad = 0;
    this.ajax.get('artData', {req: artnr})
    .then((data: any) => {
        if (!data.login) {
          this.dataError(data);
          this.blockArtList = false;
        } else {
          console.log('got5 = ', data);
          this.artShow.nr = data.artnr;
          this.artlist = [];
          this.inpArtnr = data.artnr;
          this.validArt = true;
          this.artShow.descr = data.des;
          this.artShow.eenh = data.eenh;
          this.artShow.voorraad = data.vrd;
          this.artShow.voorraadTxt = (this.artShow.voorraad%1===0)
            ? Number(this.artShow.voorraad).toFixed(0)
            : this.artShow.voorraad;
          this.updateAfgeboekt();

          this.artShow.metFoto = data.foto;
          this.artShow.serienr = (data.serienr === 'A');
          if (this.artShow.serienr) {
            this.inpQty = 1;
          } else {
            this.inpQty = null;
          }

          this.artShow.imgUrl = this.global.baseurl
            + '/api/img.php?t=artikelen&f=Foto&i=ArtNr&v=' + data.artnr
            + '&compname=' + this.global.compname
            + '&username=' + this.global.username
            + '&password=' + this.global.password
            + '&session=' + this.global.session
            + '&pcnr=' + this.global.uuid;
          this.imgs[0] = {
                filename: data.artnr,
                path: '',
                txt: data.artnr,
                url: this.artShow.imgUrl
          };

          this.global.currArtNr = data.artnr;
          localStorage.setItem('lastArtNr', data.artnr);
          this.doCheckValid();
          this.blockArtList = false;
          this.inpQtyFld.nativeElement.focus();
        }
      }
    );
  }

    updateAfgeboekt() {
        let ab = 0; // afgeboekt
        let re = 0; // reservering
        this.artShow.afgeboekt = '';
        for (const row of this.projShow.verbruik) {
            if (row.art === this.artShow.nr && (row.typ === 'R' || row.typ === 'W')) {
                re += parseFloat(row.qty);
            }
            if (row.art === this.artShow.nr && row.typ === 'B') {
                ab += parseFloat(row.qty);
            }
        }
        if (ab > 0 || re > 0) {
            this.artShow.afgeboekt = (ab%1===0)
            ? ab.toFixed(0)
            : ab;
            if (re>0) {
                this.artShow.afgeboekt += (re%1===0)
                ? ' / Gereserveerd: ' + re.toFixed(0)
                : ' / Gereserveerd: ' + re;
            }
        }
    }

  async doScanSerieNr() {
    if (!await this.global.startCamera()) {
        return;
    }
    this.scanCamera = true;
    const myDlg = await this.modalController.create({
        component: ScanCameraPage,
    });
    myDlg.onDidDismiss()
    .then((dataPar: OverlayEventDetail) => {
        this.scanCamera = false;
        if (dataPar.data.code) {
            this.inpSNr = dataPar.data.code;
            this.doCheckValid();
        } else {
            this.inpSNr = '';
            this.doCheckValid();
        }
    });
    return await myDlg.present();
  }

  /*---------------------
  * AFBOEKING
  ----------------------- */

  doType() {
    this.typeBoeking = -1 * this.typeBoeking;
    this.doSetBoekingOmsch();
    this.doCheckValid();
  }

  doSetBoekingOmsch() {
    if (this.typeBoeking < 0) {
      this.typeBoekingOmsch = 'Afboeken';
    } else {
      this.typeBoekingOmsch = 'Retour';
    }
  }

  doCheckValid() {
    const q: number = this.inpQty * this.typeBoeking;
    let TeveelRetour = false;
    let TeveelAfboek = false;
    let SerienrMist = false;
    console.log('q:', q);

    let afboeking;
    if (q > 0) {
      // retour boeking
      TeveelRetour = true;
      if (this.projShow.verbruik) {
        afboeking = this.projShow.verbruik.find(
          item => item.art === this.inpArtnr
        );
        console.log(afboeking);
        if (afboeking && afboeking.qty >= q) {
          // niet meer dan afgeboekt toestaan
          TeveelRetour = false;
        }
      }
    }
    if (q < 0) {
      // afboeking
      console.log('mode=', this.global.getvar('app-voorraad-neg', 'T'));
      if (this.global.getvar('app-voorraad-neg', 'T') === 'W') {
        // negatieve boekingen weigeren
        TeveelAfboek = (-1 * q > this.artShow.voorraad);
        console.log('q=', q, ' v=', this.artShow.voorraad);
        console.log('dus=', TeveelAfboek);
      }
    }

    if (this.artShow.serienr) {
      // serienr verplicht
      console.log('Serienr eis');
      SerienrMist = (!this.inpSNr);
      console.log(SerienrMist, this.inpSNr);
    }

    this.validBoeking = (q !== 0) && (!TeveelAfboek) && (!TeveelRetour) && (!SerienrMist) && (!this.projError);
  }

  doAfboek() {
    console.log('doAfboek');
    if (this.validBoeking) {
        const q: number = this.inpQty * this.typeBoeking * -1;
        console.log('q=', q);
        this.ajax.get('artVerbruik', {
            req: this.global.currArtNr,
            proj: this.global.currProjNr,
            serienr: this.inpSNr,
            qty: q,
            des: this.inpOms
        })
        .then((data: any) => {
            if (!data.login) {
              this.dataError(data);
            } else {
              console.log('got7 = ', data);
              this.projShow.verbruik = data.verbruik;
              this.inpArtnr = '';
              this.validArt = false;
              this.artShow.nr = '';
              this.artShow.descr = '';
              this.artShow.eenh = '';
              this.artShow.voorraad = null;
              this.artShow.voorraadTxt = '';
              this.artShow.serienr = null;
              this.inpQty = null;
              this.inpSNr = null;
              this.inpOms = '';
              this.typeBoeking = -1;
              this.doSetBoekingOmsch();
              this.inpArtFld.nativeElement.focus();
            }
          }
        );
    }
  }

    async dlgRtoB(Qty, ArtNr, Eenh) {
        const alert = await this.alertController.create({
            header: 'Afboeken',
            message: 'Afboeken van ' + ArtNr + ' [' + Eenh + ']',
            inputs: [
                {
                    name: 'q',
                    type: 'number',
                    placeholder: 'Aantal',
                    value: Qty
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('telling cancelled');
                    }
                }, {
                    text: 'Ok',
                    handler: (alertData) => {
                        this.ajax.get('artVerbruik', {
                            req: ArtNr,
                            proj: this.global.currProjNr,
                            qty: alertData.q,
                        })
                        .then((data: any) => {
                                if (!data.login) {
                                    this.dataError(data);
                                } else {
                                    console.log('got2 = ', data);
                                    this.showProjKaart(this.global.currProjNr);
                                }
                        });
                    }
                }
            ]
        });
        await alert.present();
    }

  preventPopup() {
      return false;
  }

  async dataError(data) {
    this.snackBar.open('Nieuwe login noodzakelijk.', 'OK', {
        duration: 1000
    });
    this.router.navigateByUrl('login');
  }

}
